import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import { vsprintf } from "sprintf-js";

const styles = (theme) => ({
  root: {
    margin: theme.spacing(2),
    marginTop: 35,
  },
  paper: {
    padding: theme.spacing(3),
    textAlign: "center",
  },
  successBox: {
    background: "#e8f5e9",
    border: "2px solid #4caf50",
    borderRadius: 8,
    padding: theme.spacing(3),
    margin: theme.spacing(2, 0),
  },
  errorBox: {
    background: "#ffebee",
    border: "2px solid #f44336",
    borderRadius: 8,
    padding: theme.spacing(2),
    margin: theme.spacing(2, 0),
  },
  cancelledBox: {
    background: "#fff3e0",
    border: "2px solid #ff9800",
    borderRadius: 8,
    padding: theme.spacing(2),
    margin: theme.spacing(2, 0),
  },
  button: {
    margin: theme.spacing(1),
    fontSize: "13pt",
  },
  "@media (min-width: 1024px)": {
    root: {
      width: 700,
      marginLeft: "auto",
      marginRight: "auto",
      marginTop: 90,
    },
  },
});

class RemainderPaymentResultPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = { mounted: false };
  }

  componentDidMount() {
    this.setState({ mounted: true });

    const path = window.location.pathname;

    if (path === "/remainderPaymentSuccess") {
      const params = new URLSearchParams(window.location.search);
      const uniqueID = params.get("uniqueID");
      const personalId = params.get("personalId");
      const cardMask = params.get("cardMask");
      const txId = params.get("txId");
      const authNumber = params.get("authNumber");
      const responseMAC = params.get("responseMAC");

      const traceId =
        window.crypto && window.crypto.randomUUID
          ? window.crypto.randomUUID()
          : `${Date.now()}-${Math.random().toString(16).slice(2)}`;

      this.props.depositActions.finalizeRemainderPayment({
        personalId,
        cardMask,
        txId,
        authNumber,
        responseMAC,
        uniqueID,
        traceId,
      });
    }
  }

  render() {
    const { classes, depositReducer } = this.props;
    const { remainderFinalizeResult } = depositReducer;

    // During SSR, render a simple loading state to avoid window is not defined
    if (!this.state.mounted) {
      return (
        <div className={classes.root}>
          <Paper className={classes.paper}>
            <CircularProgress size={50} />
          </Paper>
        </div>
      );
    }

    const path = window.location.pathname;

    // Loading
    if (path === "/remainderPaymentSuccess" && !remainderFinalizeResult) {
      return (
        <div className={classes.root}>
          <Paper className={classes.paper}>
            <CircularProgress size={50} />
            <Typography variant="h6" style={{ marginTop: 16 }}>
              מעבד את השלמת התשלום...
            </Typography>
          </Paper>
        </div>
      );
    }

    // Success
    if (
      path === "/remainderPaymentSuccess" &&
      remainderFinalizeResult &&
      remainderFinalizeResult.ok
    ) {
      return (
        <div className={classes.root}>
          <Paper className={classes.paper}>
            <div className={classes.successBox}>
              <Typography variant="h4" style={{ marginBottom: 16 }}>
                התשלום הושלם בהצלחה!
              </Typography>
              <Typography variant="body1">
                מספר הזמנה: <strong>{remainderFinalizeResult.orderId}</strong>
              </Typography>
              <Typography variant="body1" style={{ marginTop: 12 }}>
                מקדמה ששולמה:{" "}
                <strong>
                  {vsprintf("%.2f", [remainderFinalizeResult.depositAmount])} ₪
                </strong>
              </Typography>
              <Typography variant="body1">
                השלמת תשלום:{" "}
                <strong>
                  {vsprintf("%.2f", [remainderFinalizeResult.remainingAmount])}{" "}
                  ₪
                </strong>
              </Typography>
              <Typography
                variant="h6"
                style={{ marginTop: 12, color: "#2e7d32" }}
              >
                סה״כ שולם:{" "}
                <strong>
                  {vsprintf("%.2f", [remainderFinalizeResult.fullTotal])} ₪
                </strong>
              </Typography>
              <Typography variant="body1" style={{ marginTop: 16 }}>
                ההזמנה שלך תועבר לטיפול במהלך יום העסקים הקרוב.
              </Typography>
            </div>
            <Button
              variant="contained"
              color="primary"
              className={classes.button}
              onClick={() => (window.location.href = "/")}
            >
              חזרה לחנות
            </Button>
          </Paper>
        </div>
      );
    }

    // Failed
    if (path === "/remainderPaymentFailed") {
      return (
        <div className={classes.root}>
          <Paper className={classes.paper}>
            <div className={classes.errorBox}>
              <Typography variant="h5">התשלום נכשל</Typography>
              <Typography variant="body1" style={{ marginTop: 8 }}>
                השלמת התשלום לא בוצעה. אנא נסו שנית.
              </Typography>
            </div>
            <Button
              variant="contained"
              color="primary"
              className={classes.button}
              onClick={() => (window.location.href = "/complete-payment")}
            >
              נסה שנית
            </Button>
          </Paper>
        </div>
      );
    }

    // Cancelled
    if (path === "/remainderPaymentCanceled") {
      return (
        <div className={classes.root}>
          <Paper className={classes.paper}>
            <div className={classes.cancelledBox}>
              <Typography variant="h5">התשלום בוטל</Typography>
              <Typography variant="body1" style={{ marginTop: 8 }}>
                ביטלת את תהליך השלמת התשלום.
              </Typography>
            </div>
            <Button
              variant="contained"
              color="primary"
              className={classes.button}
              onClick={() => (window.location.href = "/complete-payment")}
            >
              חזרה להשלמת תשלום
            </Button>
          </Paper>
        </div>
      );
    }

    // Fallback
    return (
      <div className={classes.root}>
        <Paper className={classes.paper}>
          <div className={classes.errorBox}>
            <Typography variant="h5">שגיאה</Typography>
            <Typography variant="body1">
              {remainderFinalizeResult && remainderFinalizeResult.reason
                ? remainderFinalizeResult.reason
                : "אירעה שגיאה בעיבוד התשלום."}
            </Typography>
          </div>
          <Button
            variant="contained"
            color="primary"
            className={classes.button}
            onClick={() => (window.location.href = "/")}
          >
            חזרה לחנות
          </Button>
        </Paper>
      </div>
    );
  }
}

RemainderPaymentResultPage.propTypes = {
  classes: PropTypes.object.isRequired,
  depositReducer: PropTypes.object.isRequired,
  depositActions: PropTypes.object.isRequired,
};

export default withStyles(styles)(RemainderPaymentResultPage);
